import React from "react";

export const ArrowDown = () => {
    return (
        <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.1372 11.5632C11.4751 11.2378 11.4751 10.7101 11.1372 10.3847C10.7992 10.0593 10.2513 10.0593 9.91332 10.3847L6.54687 13.6265L6.54688 1.39062C6.54688 0.959152 6.1971 0.609375 5.76563 0.609375C5.33415 0.609375 4.98438 0.959152 4.98438 1.39062L4.98437 13.6265L1.61793 10.3847C1.27997 10.0593 0.732043 10.0593 0.394089 10.3847C0.0561357 10.7101 0.0561357 11.2378 0.394089 11.5632L5.1537 16.1465C5.49166 16.472 6.03959 16.472 6.37754 16.1465L11.1372 11.5632Z" fill="currentColor" />
        </svg>

    )
}